import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VedioLinksService {


 
   constructor(private http: HttpClient) { }
    
    url = environment.serverAPI4 + '/api/videoLinks';
    
  getVedioLinks() {
    return this.http.get(`${this.url}`);
  }

  getVedioLinksByName(name) {
    return this.http.get(`${this.url}/by/${name}`);
  }

}
